import React from 'react';
import {
  formatSessionDurationLabel,
  getSessionDurationInputDisplay,
  hoursToTotalMinutes,
  minutesToHoursMinutes,
} from '../../utils/customPractice';

export default function CustomPracticeSessionDuration({
  minutesValue,
  disabled,
  onDisabledClick,
  inputId = 'session_duration',
}) {
  const { mainValue, mainUnit, subValue, subUnit, hiddenMinutes } =
    getSessionDurationInputDisplay(minutesValue);
  const compactLabel = formatSessionDurationLabel(minutesValue);

  return (
    <div className="cp-session-duration cp-session-duration--readonly note-form-field">
      <label className="form-label fw-bolder text-dark fs-6" htmlFor={inputId}>
        Session Duration
      </label>
      <div className="note-form-field__control">
        <div className="cp-session-duration__compact">
          <input
            id={inputId}
            className="form-control form-control-lg form-control-solid"
            type="text"
            readOnly
            disabled={disabled}
            value={compactLabel}
            onClick={disabled ? onDisabledClick : undefined}
            placeholder="—"
            name="session_duration_display_compact"
            autoComplete="off"
          />
        </div>
        <div className="input-group cp-session-duration__group cp-session-duration__split">
          <input
            id={`${inputId}-split`}
            className="form-control form-control-lg form-control-solid"
            type="text"
            readOnly
            disabled={disabled}
            value={mainValue}
            onClick={disabled ? onDisabledClick : undefined}
            placeholder="—"
            name="session_duration_display"
            aria-describedby={`${inputId}-unit${subUnit ? ` ${inputId}-sub-unit` : ''}`}
            autoComplete="off"
          />
          <span
            className="input-group-text form-control form-control-lg form-control-solid progress-note-session-unit"
            id={`${inputId}-unit`}
          >
            {mainUnit}
          </span>
          {subValue ? (
            <>
              <input
                className="form-control form-control-lg form-control-solid cp-session-duration__sub-value"
                type="text"
                readOnly
                disabled={disabled}
                value={subValue}
                tabIndex={-1}
                aria-hidden="true"
              />
              <span
                className="input-group-text form-control form-control-lg form-control-solid progress-note-session-unit"
                id={`${inputId}-sub-unit`}
              >
                {subUnit}
              </span>
            </>
          ) : null}
        </div>
        <input type="hidden" name="session_duration" value={hiddenMinutes} />
      </div>
    </div>
  );
}

export function resolveDurationPartsFromTotalMinutes(totalMinutes) {
  const total = parseInt(totalMinutes, 10);
  if (Number.isNaN(total) || total <= 0) {
    return { hours: '', minutesPart: '', unit: 'minutes' };
  }
  const { hours, minutes } = minutesToHoursMinutes(total);
  if (total < 60 || (hours === 0 && minutes > 0)) {
    return {
      hours: '',
      minutesPart: String(minutes || total),
      unit: 'minutes',
    };
  }
  return {
    hours: String(hours),
    minutesPart: String(minutes),
    unit: 'hours',
  };
}

export function totalMinutesFromDurationParts(hours, minutesPart, unit) {
  if (unit === 'minutes') {
    const m = parseInt(minutesPart, 10);
    return Number.isNaN(m) || m < 0 ? '' : m;
  }
  return hoursToTotalMinutes(hours);
}
